// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activate-button {
  background-color: red;
}

.a-button {
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  text-decoration: none;
  color: white;
  outline-offset: 6px !important;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.selected-page {
  text-decoration: underline;
  font-weight: bold;
}

.delete-modal .modal-wrapper {
  height: 30%;
  width: 90%;
  border-radius: 15px;
}

.modal-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  min-height: 56px;
}

@media (prefers-color-scheme: dark) {
  *:focus {
    outline-color: white !important;
  }
}
@media (prefers-color-scheme: light) {
  .a-button {
    color: #222428;
    outline-offset: 7px !important;
  }
}
.page-button {
  color: var(--nav-text-color);
  text-decoration: none;
  padding: 0.5rem 1rem;
  display: inline-block;
  letter-spacing: 0.5px;
  font-weight: 300;
}

.inactive-page-button {
  color: var(--ion-color-medium);
  text-decoration: none;
  padding: 0.5rem 1rem;
  display: inline-block;
}

.selected-page {
  border-bottom: 1px solid var(--color-primary-contrast);
}

.a-button {
  cursor: pointer;
}

.modal {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  max-width: 500px;
  border-radius: 5px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.modal-title {
  font-size: 1.25rem;
  font-weight: bold;
}

.modal-body {
  margin-bottom: 15px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.first-button {
  margin-left: -18px;
}`, "",{"version":3,"sources":["webpack://./src/app/core/header/page-button/page-button.component.scss"],"names":[],"mappings":"AAOA;EAME,qBAAA;AAXF;;AAcA;EAEE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;AAZF;;AAgBA;EACE,0BAAA;EACA,iBAAA;AAbF;;AAmBE;EACI,WAAA;EACA,UAAA;EACA,mBAAA;AAhBN;;AAqBA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AAlBF;;AAsBA;EAEE;IACE,+BAAA;EApBF;AACF;AAuBA;EACE;IACE,cAAA;IACA,8BAAA;EArBF;AACF;AAwBA;EACE,4BAAA;EAEA,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AAvBF;;AA0BA;EACE,8BAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;AAvBF;;AA0BA;EACE,sDAAA;AAvBF;;AA0BA;EACE,eAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,oCAAA;AAvBF;;AA0BA;EACE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAvBF;;AA0BA;EACE,kBAAA;EACA,iBAAA;AAvBF;;AA0BA;EACE,mBAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AAvBF;;AA0BA;EACE,kBAAA;AAvBF","sourcesContent":[".delete-button {\r\n  // margin-bottom: 1.2vh;\r\n  // margin-right: -0.1vw;\r\n  // width: 2vh;\r\n  // height: 2vh;\r\n  // line-height: 2vw;\r\n}\r\n.activate-button {\r\n  // margin-bottom: -1.8vh;\r\n  // margin-right: -0.1vw;\r\n  // width: 2vh;\r\n  // height: 2vh;\r\n  // line-height: 2vw;\r\n  background-color: red;\r\n}\r\n\r\n.a-button {\r\n  // margin: 1vw;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  text-decoration: none;\r\n  color: white;\r\n  outline-offset: 6px !important;\r\n  letter-spacing: 0.5px;\r\n  white-space: nowrap;\r\n\r\n}\r\n\r\n.selected-page {\r\n  text-decoration: underline;\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n\r\n.delete-modal {\r\n  .modal-wrapper {\r\n      height: 30%;\r\n      width: 90%;\r\n      border-radius: 15px;\r\n    }\r\n}\r\n\r\n\r\n.modal-footer {\r\n  position: fixed;\r\n  bottom: 0;\r\n  width: 100%;\r\n  min-height: 56px;\r\n}\r\n\r\n\r\n@media (prefers-color-scheme: dark) {\r\n\r\n  *:focus {\r\n    outline-color: white !important;\r\n  }\r\n}\r\n\r\n@media (prefers-color-scheme: light) {\r\n  .a-button {\r\n    color: #222428;\r\n    outline-offset: 7px !important;\r\n  }\r\n}\r\n\r\n.page-button {\r\n  color: var(--nav-text-color);\r\n\r\n  text-decoration: none;\r\n  padding: 0.5rem 1rem;\r\n  display: inline-block;\r\n  letter-spacing: 0.5px;\r\n  font-weight: 300;\r\n}\r\n\r\n.inactive-page-button {\r\n  color: var(--ion-color-medium);\r\n  text-decoration: none;\r\n  padding: 0.5rem 1rem;\r\n  display: inline-block;\r\n}\r\n\r\n.selected-page {\r\n  border-bottom: 1px solid var(--color-primary-contrast);\r\n}\r\n\r\n.a-button {\r\n  cursor: pointer;\r\n}\r\n\r\n.modal {\r\n  display: none;\r\n  position: fixed;\r\n  z-index: 1000;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: auto;\r\n  background-color: rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.modal-content {\r\n  background-color: #fefefe;\r\n  margin: 15% auto;\r\n  padding: 20px;\r\n  border: 1px solid #888;\r\n  width: 80%;\r\n  max-width: 500px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.modal-title {\r\n  font-size: 1.25rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.modal-body {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.modal-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n}\r\n\r\n.first-button {\r\n  margin-left: -18px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
